import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import isFunction from 'lodash/isFunction';
import kebabCase from 'lodash/kebabCase';

function RsTableToolbarButton({ className, icon, label, onClick, disabled = false, ...rest }) {
  const kebabLabel = kebabCase(label);

  return (
    <Button
      onClick={(e) => {
        e.preventDefault();
        isFunction(onClick) && onClick({});
      }}
      disabled={disabled}
      buttonConfig={{
        className: cn([`rs-table-toolbar__button rs-table-toolbar__button--${kebabLabel}`, className]),
        label,
        type: 'link',
        size: 'tiny',
        e2eName: `rs-toolbar-button-${kebabLabel}`,
        ariaLabel: label,
      }}
      iconConfig={{
        position: 'before',
        name: icon,
        size: 'sm',
      }}
      {...rest}
    />
  );
}

RsTableToolbarButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RsTableToolbarButton;
